import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import { formBodyType } from '../../util/uiconstants';

export function deficiencyReducer(state = initialstate.deficiency, action) {
	switch (action.type) {
		case types.GET_DEFICIENCY_BY_ID:
			if (Object.keys(state).length > 0 && action.actionArgs) {
				let updatedState = { ...state };

				switch (action.actionArgs.formBodyTypeId) {
					case formBodyType.RelateControlToDeficiency:
						updatedState.relatedControls = action.response?.relatedControls || [];
						break;
					case formBodyType.RelateCompensatingControlsToDeficiency:
						updatedState.relatedCompensatingControls = action.response?.relatedCompensatingControls || [];
						break;
					case formBodyType.RelateAssertionToDeficiency:
						updatedState.relatedAssertions = action.response?.relatedAssertions || [];
						break;
					case formBodyType.RelateSTEntityToDeficiency:
						updatedState.relatedSTEntities = action.response?.relatedSTEntities || [];
						break;
					case formBodyType.RelateGAComponentToDeficiency:
						updatedState.relatedGroupComponents = action.response?.relatedGroupComponents || [];
						break;
					case formBodyType.RelateITControlToDeficiency:
						updatedState.relatedITControls = action.response?.relatedITControls || [];
						break;
					case formBodyType.RelateITApplicationToDeficiency:
						updatedState.relatedITApplications = action.response?.relatedITApplications || [];
						break;
					case formBodyType.RelateCompensatingITControlsToDeficiency:
						updatedState.relatedCompensatingITControls = action.response?.relatedCompensatingITControls || [];
						break;
				}

				return updatedState; 
			}
			return action.response || state;
		default:
			return state;
	}
}
